/* eslint no-shadow: ["error", { "allow": ["state", "mutations", "getters"] }] */
import {
  map,
  isNil,
} from 'lodash';

import {
  fetchToken,
  fetchUser,
  updateUser,
  restoreUserPassword,
  fetchProfilers,
} from '@/api';

export const state = {
  instance: '',
  token: {},
  user: {},
  password: '',
  profilers: [],
};

export const getters = {
  isDone(state) {
    return !isNil(state.token.token_type && state.token.access_token);
  },
  FORMATTED_TOKEN(state) {
    return `${state.token.token_type} ${state.token.access_token}`;
  },
};

export const mutations = {
  setInstance(state, instance) {
    state.instance = instance;
  },
  setToken(state, token) {
    state.token = token;
  },
  setUser(state, user = {}) {
    state.user = user;
  },
  setPassword(state, password = '') {
    state.password = password;
  },
  setProfilers(state, profilers = []) {
    state.profilers = profilers;
  },
};

export const actions = {
  async doLogin({
    commit,
    state,
    getters,
  }, {
    instance,
    username,
    password,
    token,
  }) {
    const localToken = token || await fetchToken({
      instance,
      username,
      password,
      returnUrl: encodeURIComponent('/access/#/login-bridge'),
    });
    commit('setInstance', instance);
    commit('setToken', localToken);
    commit('setUser', await fetchUser({
      token: getters.FORMATTED_TOKEN,
      username,
    }));
    commit('setPassword', password);
    commit('setProfilers', await fetchProfilers({
      token: getters.FORMATTED_TOKEN,
      userId: state.user.id,
    }));

    const projects = map(state.profilers, profiler => ({
      ...profiler.projectEntity,
      profiler,
    }));

    commit('setProjects', projects, {
      root: true,
    });
  },
  doLogout({
    commit,
  }) {
    commit('setToken', {});
    commit('setUser', {});
    commit('setPassword', '');
    commit('setProfilers', []);
    commit('setProjects', [], {
      root: true,
    });
    commit('setProjectSearchText', '', {
      root: true,
    });
  },
  async updateAndSetUser({
    commit,
    getters,
  }, {
    id,
    name,
    mail,
  }) {
    const user = await updateUser({
      token: getters.FORMATTED_TOKEN,
      id,
      name,
      mail,
      audit: {
        userId: id,
      },
    });
    commit('setUser', user);
  },
  async restoreUserPasswordAndSetUser({
    commit,
    getters,
  }, {
    instance,
    userEntity,
  }) {
    const user = await restoreUserPassword({
      instance,
      userEntity,
      token: getters.FORMATTED_TOKEN,
    });
    commit('setUser', user);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
